import { apiRequest } from './client';
import { catalogConfig } from '../config/catalog';

export default async function getSkus(searchTerm, verified, signal) {
  if (searchTerm === "") {
    return null;
  }


  let params = {};
  if (!isNaN(Number(searchTerm))) {
    params = {
      cnpj: catalogConfig.cnpj,
      ean: searchTerm,
      verificados: verified,
      apenas_itens_com_imagem: true
    }
  }
  else {
    params = {
      cnpj: catalogConfig.cnpj,
      termo: searchTerm,
      quantidade: 18,
      verificados: verified,
      apenas_itens_com_imagem: true
    }
  }
  
  

  const response = await apiRequest('/search/v2/sku', { params, signal });

  if (response?.skus) {
    response.skus = response.skus.filter(i =>
      !i.images?.[0]?.url_ds?.includes("nofigure")
    );
  }

  return response;
}
